import React from 'react';
import { onSetActivePage, onSetActiveGeography } from '../../data/StatusStore';
interface SpreadOutScreenProps {
  isOpen: boolean;
  onClose: () => void;
}

const SpreadOutScreen: React.FC<SpreadOutScreenProps> = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    // Clicking the semi-transparent overlay closes the splash
    const handleOverlayClick = () => {
        onClose();
    };

    // Prevent closing when clicking inside the dialog
    const handleDialogClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    };

    const hdiDataStory = () => {
        console.log('HDI Data Story clicked');
        onSetActiveGeography('CD');
        onSetActivePage('stories');
        onClose();
    };
    const getStarted = () => {
        console.log('Get Staerted');
        onClose();
    };

    return (
        <div
        className="splash-overlay"
        onClick={handleOverlayClick}
        style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgb(165 96 0 / 0%)',
            zIndex: 999999, // High enough to cover navbar
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        >
            <div
                className="splash-dialog"
                onClick={handleDialogClick}
                style={{
                position: 'relative',
                width: '469px',
                maxWidth: '90%',
                backgroundColor: '#F5F5F5',
                padding: '24px 30px',
                borderRadius: '25px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                fontFamily: 'Arial, sans-serif',
                textAlign: 'left',
                lineHeight: 1.5,
                border: '2px solid black',
                }}
            >
                {/* Close Button (X) */}
                <button
                onClick={onClose}
                style={{
                    position: 'absolute',
                    top: '16px',
                    right: '16px',
                    background: 'transparent',
                    border: 'none',
                    fontSize: '1.5rem',
                    cursor: 'pointer',
                    lineHeight: '1',
                }}
                >
                &times;
                </button>
                <p style={{ margin: '40px', fontSize: '18px', lineHeight:'22px', textAlign: 'center' }}>
                DATA2GO.NYC likes to spread out.<br/>
                Please use full screen or make the window as large as you can. If using an iPad, DATA2GO performs best in landscape (horizontal) view. 
                </p>
            </div>
        </div>
    );
};

export default SpreadOutScreen;
